var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 2.18888C5.33333 1.82069 5.63181 1.52222 6 1.52222H10C10.3682 1.52222 10.6667 1.82069 10.6667 2.18888C10.6667 2.55707 10.3682 2.85555 10 2.85555H6C5.63181 2.85555 5.33333 2.55707 5.33333 2.18888ZM2 4.30653C2 3.93834 2.29848 3.63986 2.66667 3.63986H13.3333C13.7015 3.63986 14 3.93834 14 4.30653C14 4.67472 13.7015 4.9732 13.3333 4.9732H12.6377C12.6386 5.00467 12.6385 5.03629 12.6372 5.06801L12.3333 12.7914C12.3259 13.8969 11.4684 14.8556 10.3333 14.8556H5.66667C4.53161 14.8556 3.67406 13.8969 3.66671 12.7914L3.36278 5.06801C3.36153 5.03629 3.36138 5.00467 3.36229 4.9732H2.66667C2.29848 4.9732 2 4.67472 2 4.30653ZM4.70644 4.9732C4.7011 4.98003 4.69423 4.9938 4.69509 5.01559L5 12.764V12.7771C5 13.225 5.33387 13.5222 5.66667 13.5222H10.3333C10.6661 13.5222 11 13.225 11 12.7771V12.764L11.3049 5.01558C11.3058 4.9938 11.2989 4.98003 11.2936 4.9732H4.70644ZM6.66667 6.46339C7.03486 6.46339 7.33333 6.76187 7.33333 7.13006V11.3654C7.33333 11.7335 7.03486 12.032 6.66667 12.032C6.29848 12.032 6 11.7335 6 11.3654V7.13006C6 6.76187 6.29848 6.46339 6.66667 6.46339ZM9.33333 6.46339C9.70152 6.46339 10 6.76187 10 7.13006V11.3654C10 11.7335 9.70152 12.032 9.33333 12.032C8.96514 12.032 8.66667 11.7335 8.66667 11.3654V7.13006C8.66667 6.76187 8.96514 6.46339 9.33333 6.46339Z",
    fill: "#E75858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash01);
export default __webpack_public_path__ + "static/media/ic-trash-01.cced1915a72e45985e09beaaa11b057d.svg";
export { ForwardRef as ReactComponent };